import { useState } from 'react'
import type { FormEvent } from 'react'
import styled from 'styled-components'

// import { useAlert } from '../../../hooks'

import { Wrap } from '../../../components/container/Wrap'
import { Content } from '../../../components/container/Content'
import { Header } from '../../../components/header'
import { Text } from '../../../components/text'
import { Input } from '../../../components/input/Input'
import { Button } from '../../../components/button'
import { NoticeContainer } from '../../../components/noticeContainer/NoticeContainer'

export const Email = () => {
  const [email, setEmail] = useState<string>('')

  // const openAlert = useAlert()

  const changeEmail = ({ currentTarget: { value } }: FormEvent<HTMLInputElement>) => {
    setEmail(typeof value === 'string' ? value : '')
  }

  const certifyMail = () => {
    console.log({ email })
  }

  // const successCertifyMail = () => {
  //   openAlert({ content: '이메일 인증이 완료되었습니다.' })
  // }

  return (
    <Wrap>
      <Header type="SUB" title="이메일" />
      <Content>
        <Container>
          <Text size={20} weight={700}>
            이메일 주소 입력 후
            <br />
            이메일 인증 버튼을 눌러주세요.
          </Text>
          <div>
            <Input placeholder="이메일 주소를 입력해주세요" onInput={changeEmail} />
            <Button type="primary" onClick={certifyMail}>
              이메일 인증
            </Button>
          </div>
          <NoticeContainer
            title="유의사항"
            list={[
              '인증 받은 이메일을 통해 아티피오의 공지사항 및 다양한 소식이 발송됩니다.',
              '인증 메일을 받지 못하셨다면 스팸메일함을 확인해 주세요.',
              '이메일을 잘못 입력하여 받으시는 불이익은 당사에서 책임지지 않습니다.',
            ]}
          />
        </Container>
      </Content>
      {/* <FooterButtons
        button={{
          color: 'dark',
          text: '확인',
          disabled: !email.trim(),
          onClick: successCertifyMail,
        }}
      /> */}
    </Wrap>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px;
`
